import moment from 'moment';
import React, { useState } from 'react'

export default function EditLiveNotificationSchedule(props: {
    saveHandler: (newDateStr:string) => void,
    cancleHandler: () => void
}) {
    const { saveHandler, cancleHandler } = props;
    const [newDatetimeStr, setNewDatetimeStr] = useState<string>();
    return (
        <div>
            <div>


                <input
                    type="datetime-local"
                    value={newDatetimeStr}
                    onChange={(e) => { setNewDatetimeStr(e.target.value) }}
                    min={moment.utc().format("YYYY-MM-DDThh:mm")}

                />
            </div>
            <div>
                <button onClick={()=>newDatetimeStr && saveHandler(newDatetimeStr)} disabled={newDatetimeStr===undefined}>Save</button>
                <button onClick={cancleHandler}>Cancle </button>
            </div>


        </div>
    )
}
